import { MFALockout } from '@organization/api/requests'
import { ConditionalText, DateTimeCell, TableActions } from '@shared/components'
import { MenuProps } from 'antd'
import { ColumnProps } from 'antd/es/table'
import { TFunction } from 'i18next'

export const getTableColumns = (
  actions: (content: MFALockout) => MenuProps['items'],
  t: TFunction
): ColumnProps<MFALockout>[] => [
  {
    title: t('table.user'),
    dataIndex: 'user_username',
    key: 'user_username'
  },
  {
    title: t('table.locked_until'),
    dataIndex: 'locked_until',
    key: 'locked_until',
    render: (date) => <DateTimeCell date={date} />
  },
  {
    title: t('table.type'),
    dataIndex: 'lockout_type',
    key: 'lockout_type',
    render: (type) => t(`lockout_type.${type}`, type).toString()
  },
  {
    title: t('table.reason'),
    dataIndex: 'reason',
    key: 'reason',
    render: (value) => (
      <ConditionalText condition={!!value}>{value}</ConditionalText>
    )
  },
  {
    title: t('table.date_created'),
    dataIndex: 'created_at',
    key: 'created_at',
    render: (date) => <DateTimeCell date={date} />
  },

  {
    key: 'actions',
    align: 'center',
    width: 80,
    render: (_, row) => <TableActions options={actions(row)} />
  }
]
